module.exports = __webpack_public_path__ + "img/adviser.acca7d2b.png";